export class DatosAhorroProgramadoModel {
  MontoMeta!: number;
  CuotaAhorro!: number;
  CodMetaAhorro!: string;
  MotivoAhorro!: string;
  Plazo!: string;
  DepositoInicial!: number;
  DiaDebito!: number;

  clear() {
    this.MontoMeta = 0;
    this.CuotaAhorro = 0;
    this.CodMetaAhorro = '';
    this.MotivoAhorro = '';
    this.Plazo = '';
    this.DepositoInicial = 0;
    this.DiaDebito = 0;
  }
  
}
